<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('course_application_evaluation')" :isFilter="false" />
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('course_application_evaluation')" :isFilter="false" />
            </template>

            <b-col v-if="!data" class="d-flex justify-content-center align-items-center" style="min-height: 400px">
                <b-spinner variant="primary" label="Loading..."></b-spinner>
            </b-col>
            <b-col v-else-if="!activeStep" class="d-flex justify-content-center align-items-center" style="min-height: 400px">
                <div class="col-12">
                    <div class="row border p-2 d-flex justify-content-center align-items-center">
                        <div class="d-flex flex-column align-items-center">
                            <i class="ri-information-line" style="font-size: 100px">
                            </i>
                            <p>
                                {{$t('active_step_not_found')}}
                            </p>
                        </div>
                    </div>
                </div>
             </b-col>

            <div v-else>
                <ValidationObserver ref="formValidate">
                <div class="row mb-5 align-items-center" v-if="data != null">
                    <div class="col-12">
                        <div class="row border mb-2 p-2">
                            <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                                <b-form-group :label="$t('student_number')">
                                    {{ data.student_number }}
                                </b-form-group>
                            </div>
                            <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                                <b-form-group :label="$t('name_surname')">
                                    {{ data.name }} {{ data.surname }}
                                </b-form-group>
                            </div>
                            <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                                <b-form-group :label="$t('program')">
                                    {{ this.getLocaleText(data, 'program_name') }}
                                </b-form-group>
                            </div>
                            <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                                <b-form-group :label="$t('class')">
                                    {{ this.getLocaleText(data, 'class_name') }}
                                </b-form-group>
                            </div>
                            <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                                <b-form-group :label="$t('registration_type')">
                                    {{ this.getLocaleText(data, 'registration_type') }}
                                </b-form-group>
                            </div>
                            <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                                <b-form-group :label="$t('number_of_semesters')">
                                    {{ data.number_of_semesters }}
                                </b-form-group>
                            </div>
                            <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                                <b-form-group :label="$t('cgpa')">
                                    {{ data.cgpa }}
                                </b-form-group>
                            </div>
                            <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                                <b-form-group :label="$t('status')">
                                    {{ getLocaleText(data,'status_name') }}
                                </b-form-group>
                            </div>

                        </div>
                    </div>

                </div>
                <div>
                    <div class="d-flex align-items-center justify-content-between">
                        <h6 class="mb-4">{{ $t('courses').toUpper() }}</h6>
                    </div>
                    <div class="table-responsive">
                        <table class="table table-bordered table-hover"   id="scroll">
                            <thead class="thead-dark">
                            <tr>
                                <th scope="col">{{ $t('slot_type').toUpper() }}</th>
                                <th scope="col" class="width-100">{{ $t('course_code').toUpper() }}</th>
                                <th scope="col">{{ $t('course_name').toUpper() + ' / ' + $t('elective_pool').toUpper() }}</th>
                                <th scope="col">{{ $t('credit').toUpper() }}</th>
                                <th scope="col">{{ $t('ects_credit').toUpper() }}</th>
                                <th scope="col">{{ $t('semester').toUpper() }}</th>
                                <th scope="col">{{ $t('selected_course').toUpper() }}</th>
                                <th scope="col" v-if="activeStep?.rank===1"
                                >{{ $t('action').toUpper() }}</th>
                                <th scope="col" v-if="activeStep?.rank===1"
                                >{{ $t('reason_for_rejection').toUpper() }}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(slot,key) in slots" :key="slot.id">
                                <td>{{ slot.slot_type }}</td>
                                <td>{{ slot.course ? slot.course.code : '' }}</td>
                                <td>
                                    {{
                                        slot.course
                                            ? getLocaleText(slot.course, 'name')
                                            : slot.pool
                                                ? getLocaleText(slot.pool, 'name')
                                                : ''
                                    }}
                                </td>
                                <td>{{ slot.credit }}</td>
                                <td>{{ slot.ects_credit }}</td>
                                <td>{{ slot.semester }}</td>
                                <td>
                                    <strong>
                                        {{
                                            slot.selected_course
                                                ? slot.selected_course.name + ' (' + slot.selected_course.code + ')'
                                                : ''
                                        }}
                                    </strong>
                                </td>
                                <td v-if="slot.show && activeStep.rank===1">
                                    <ValidationProvider
                                        :name="'approvalStatus'+slot.id"
                                        rules="required"
                                        v-slot="{errors}"
                                    >
                                        <div>
                                                <b-form-select
                                                    :disabled="slot.selected_course?.status==='approved'"
                                                    v-model="slot.approvalStatus"
                                                    :options="options"
                                                    class="form-select"
                                                    @change="onApprovalChangeSelect(slot)"
                                                    style="width: 120px"
                                                    :ref="'select-' + slot.id"
                                                    :id="'scrollvee-approvalStatus'+slot.id"
                                                ></b-form-select>
                                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]">
                                            </b-form-invalid-feedback>
                                        </div>
<!--                                        <div  v-else class="text-center">-->
<!--                                            <b-form-group readonly>-->
<!--                                                {{ getLocaleText(slot.selected_course, 'status_name') }}-->
<!--                                            </b-form-group>-->
<!--                                        </div>-->
                                    </ValidationProvider>

                                </td>
                                <td v-else-if="activeStep.rank===1"></td>
                                <td v-if="slot.approvalStatus === 'declined' && slot.show"
                                >
                                    <ValidationProvider
                                        :name="'reason'+slot.id"
                                        :rules="slot.approvalStatus === 'declined' ? 'required' : ''"
                                        v-slot="{errors}"
                                    >
                                        <b-form-textarea
                                            :disabled="activeStep?.rank===2"
                                            :ref="'textarea-' + slot.id"
                                            :id="'scrollvee-reason'+slot.id"
                                            v-model="slot.reason"
                                            :placeholder="$t('write_reason_for_rejection')"
                                            rows="3"
                                            max-rows="6"
                                            class="form-control"
                                            style="width: 120px"
                                        ></b-form-textarea>
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]">
                                        </b-form-invalid-feedback>
                                    </ValidationProvider>
                                </td>
                                <td v-else-if="activeStep.rank===1"></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    </div>
                <div class="mb-3 d-inline-block"></div>
                <b-col class="border p-3 d-flex flex-column  justify-content-center align-items-center">
                    <b-col md="6" xs="12">
                        <ValidationProvider name="status" rules="required" v-slot="{ errors }">
                            <b-form-group :label="$t('status')">
                                <multi-selectbox
                                    v-model="form.status" :multiple="false"
                                    :options="statusesOptions" :validate-error="errors[0]"
                                ></multi-selectbox>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col md="6" xs="12" v-if="form.status==='declined'">
                        <ValidationProvider name="reason" :rules="form.status==='declined'?'required':''" v-slot="{ errors }">
                            <b-form-textarea
                                id="textarea"
                                v-model="form.reason"
                                :placeholder="$t('write_reason_for_rejection')"
                                rows="3"
                                max-rows="6"
                            ></b-form-textarea>

                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]">
                            </b-form-invalid-feedback>
                        </ValidationProvider>
                    </b-col>
                </b-col>
                </ValidationObserver>
                <div class="d-flex justify-content-center">
                    <b-button size="sm" variant="primary" @click="applicationApprove" class="small mt-5">
                        {{ $t('application_approve').toUpper() }}
                    </b-button>
                </div>
            </div>
    </app-layout>
    </div>
</template>
<script>
// Template
import AppLayout from "@/layouts/AppLayout";
import Header from "@/layouts/AppLayout/Header";
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile";

// Services
import StudentCourseAgreementServices from "@/services/StudentCourseAgreementServices";


export default {
    components: {
        AppLayout,
        Header,
        HeaderMobile,
    },
    data() {
        return {
            form:{},
            data: null,
            slots: null,
            errors:[],
            activeStep: null,
            options:[
                {
                    text:this.$t('select'),
                    value:null
                },
                {
                    text:this.$t('approved'),
                    value:'approved'
                },
                {
                    text:this.$t('declined'),
                    value:'declined'
                }
            ]
        }
    },
    metaInfo() {
        return {
            title: this.$t("course_application_evaluation")
        }
    },
    created() {
        this.getInformation()
    },
    computed:{
        statusesOptions(){
            const options =[]
            if (this.activeStep?.statuses){
                Object.entries(this.activeStep.statuses).forEach(([key,value])=>{
                    options.push({
                        text:this.getLocaleText(value,'name'),
                        value:key
                    })
                })
            }

            return options

        },
    },
    methods: {
        async getInformation() {
            try {
                const res = await StudentCourseAgreementServices.getStudentCourses(this.$route.params.id)
                this.data = res.data.data
                this.activeStep=res.data.data.active_step
                this.slots=res.data.data.slots.map(item=>{
                    return {
                        ...item,
                        approvalStatus:item.selected_course?.status==='approved'?'approved':null,
                        reason:null,
                        show:item.selected_course!=null
                    }
                })
            } catch (error) {
                this.showErrors(error)
            }
        },
       async applicationApprove(){
            const isValid=await this.$refs.formValidate.validate()
           if (!isValid){
               const errors=this.$refs.formValidate.errors
               for (const [key, value] of Object.entries(errors)) {
                   if (value.length > 0) {
                       const element = document.getElementById(`scrollvee-${key}`);
                       if (element) {
                           element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                       }
                       break;
                   }
               }
               return;
           }
           const selectedApplication =this.slots.filter((item)=>item.show)
           const data = selectedApplication.map((item)=>{
               return {
                   id:item.selected_course.id,
                   reason:item.reason,
                   status:item.approvalStatus
               }
           })
           const config = {
                   courses:[
                       ...data
                   ],
                status:this.form.status,
           }
           if (this.form.status==='declined'){
               config.reason=this.form.reason
           }
           StudentCourseAgreementServices.approvedApplication(config,this.activeStep.id)
               .then((response) => {
                   this.$toast.success(this.$t('api.' + response.data.message))
                   window.location.reload();
               }).catch(error => {
                   this.showErrors(error,this.$refs.formValidate)
               })
        },
        onApprovalChangeSelect(slot){
            if (slot.approvalStatus==='approved'){
                slot.reason=null
            }
        },


    },

    watch:{
        'form.status'(newVal    ){
            if (newVal!=='declined'){
                this.form.reason = null
            }
        }
    }
};
</script>
